/* eslint-disable */

export default {
  'Get </amount>': 'Получить ${{</amount>}}',
  'Enter a promo code! First limit people receive amount coins':
    'Успей ввести промо код! Первые limit человек получают amount монет',
};
